import React from 'react';
import BeginnerPathway from './BeginnerPathway';
import AdvancedPathway from './AdvancedPathway';
import {SchoolOutlined} from '@mui/icons-material';

const PathwaysList = () => {

    return (
        <div className="container mx-auto px-4 py-4 lg:px-[5%]" id="book">
            <div className="bg-white rounded-xl shadow-md p-6 mb-8">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
                    <div className="flex items-center">
                        <SchoolOutlined className="text-indigo-600 w-10 h-10 mr-3"/>
                        <h1 className="text-3xl font-bold text-gray-900">
                            Parcours d'Apprentissage Télédétection Radar
                        </h1>
                    </div>
                </div>

                <div className="prose max-w-none mb-6">
                    <p>
                        Ces parcours d'apprentissage sont conçus pour vous accompagner dans la découverte et la maîtrise
                        de la télédétection radar,
                        des concepts fondamentaux aux applications avancées. Choisissez le parcours qui correspond à
                        votre niveau et à vos objectifs.
                    </p>
                </div>
            </div>

            <BeginnerPathway/>
            <AdvancedPathway/>


        </div>
    );
};

export default PathwaysList;